// https://github.com/excid3/tailwindcss-stimulus-components/blob/master/src/tabs.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    this.tabTargets.forEach((tab) => {
      tab.addEventListener("click", this.change.bind(this));
    });

    this.activeTabClasses = (this.data.get("activeTab") || "active").split(" ");
    this.inactiveTabClasses = (this.data.get("inactiveTab") || "inactive").split(" ");

    // Check for tab query parameter first
    const tabParam = this.getTabParam();
    if (tabParam) {
      this.index = this.tabTargets.findIndex((tab) => tab.id === `tab_${tabParam}`);
    } else {
      // Find the initially active tab from server-side rendering
      const activeTabIndex = this.tabTargets.findIndex((tab) => tab.dataset.state === "active");
      if (activeTabIndex >= 0) {
        this.index = activeTabIndex;
      }
    }

    this.showTab();
  }

  change(event) {
    // If target specifies an index, use that
    if (event.currentTarget.dataset.index) {
      this.index = event.currentTarget.dataset.index;

      // If target specifies an id, use that
    } else if (event.currentTarget.dataset.id) {
      this.index = this.tabTargets.findIndex((tab) => tab.id == event.currentTarget.dataset.id);

      // Otherwise, use the index of the current target
    } else {
      this.index = this.tabTargets.indexOf(event.currentTarget);
    }

    // Show tab immediately after changing index
    this.showTab();

    // Update URL with tab parameter
    this.updateTabParam();

    window.dispatchEvent(new CustomEvent("tsc:tab-change"));
  }

  showTab() {
    this.tabTargets.forEach((tab, index) => {
      const panel = this.panelTargets[index];

      if (index === this.index) {
        panel.classList.remove("hidden");
        tab.classList.remove(...this.inactiveTabClasses);
        tab.classList.add(...this.activeTabClasses);
        tab.dataset.state = "active";
        panel.dataset.state = "active";

        // Tab parameter update is handled by updateTabParam() method
      } else {
        panel.classList.add("hidden");
        tab.classList.remove(...this.activeTabClasses);
        tab.classList.add(...this.inactiveTabClasses);
        tab.dataset.state = "inactive";
        panel.dataset.state = "inactive";
      }
    });
  }

  get index() {
    return parseInt(this.data.get("index") || 0);
  }

  set index(value) {
    this.data.set("index", value >= 0 ? value : 0);
    this.showTab();
  }

  getTabParam() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("tab");
  }

  updateTabParam() {
    const currentTab = this.tabTargets[this.index];
    if (currentTab && currentTab.id) {
      const url = new URL(window.location);
      // Extract tab name from id (e.g., "tab_knowledge-bases" -> "knowledge-bases")
      const tabName = currentTab.id.replace(/^tab_/, "");
      // Preserve existing search parameters when setting tab parameter
      url.searchParams.set("tab", tabName);
      window.history.replaceState({}, "", url);
    }
  }
}
